import { render } from "./GiftCardRewardNew.vue?vue&type=template&id=bb776660&scoped=true"
import script from "./GiftCardRewardNew.vue?vue&type=script&lang=js"
export * from "./GiftCardRewardNew.vue?vue&type=script&lang=js"

import "./GiftCardRewardNew.vue?vue&type=style&index=0&id=bb776660&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb776660"]])

export default __exports__